'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AbstractReactComponent = require('../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

require('./DetailLeftIcon.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta, která obaluje obsah, který má vlevo na deailku velikou ikonu, slouží i pro ostatní řádky pod, které nemají ikonu, ale mají být správně odsazené.
 */
// --
var DetailLeftIcon = function (_AbstractReactCompone) {
    (0, _inherits3.default)(DetailLeftIcon, _AbstractReactCompone);

    function DetailLeftIcon() {
        (0, _classCallCheck3.default)(this, DetailLeftIcon);
        return (0, _possibleConstructorReturn3.default)(this, (DetailLeftIcon.__proto__ || (0, _getPrototypeOf2.default)(DetailLeftIcon)).apply(this, arguments));
    }

    (0, _createClass3.default)(DetailLeftIcon, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                icon = _props.icon,
                children = _props.children,
                className = _props.className,
                leftClassName = _props.leftClassName,
                rightClassName = _props.rightClassName,
                other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'children', 'className', 'leftClassName', 'rightClassName']);


            var wrapperClassNames = (0, _classnames2.default)("detail-left-icon-container", className);
            var leftClassNames = (0, _classnames2.default)("detail-left-icon", leftClassName);
            var rightClassNames = (0, _classnames2.default)("detail-left-content", rightClassName);

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({ className: wrapperClassNames }, other),
                _react2.default.createElement(
                    'div',
                    { className: leftClassNames },
                    icon
                ),
                _react2.default.createElement(
                    'div',
                    { className: rightClassNames },
                    children
                )
            );
        }
    }]);
    return DetailLeftIcon;
}(_AbstractReactComponent2.default);

DetailLeftIcon.propTypes = {
    icon: _react2.default.PropTypes.element, // blok s ikonami
    children: _react2.default.PropTypes.node, // blok s obsahem
    leftClassName: _react2.default.PropTypes.string, // class pro levou část s ikonou
    rightClassName: _react2.default.PropTypes.string // class pro pravOu část s obsahem
};
exports.default = DetailLeftIcon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZGV0YWlsL0RldGFpbExlZnRJY29uLmpzeCJdLCJuYW1lcyI6WyJEZXRhaWxMZWZ0SWNvbiIsInByb3BzIiwiaWNvbiIsImNoaWxkcmVuIiwiY2xhc3NOYW1lIiwibGVmdENsYXNzTmFtZSIsInJpZ2h0Q2xhc3NOYW1lIiwib3RoZXIiLCJ3cmFwcGVyQ2xhc3NOYW1lcyIsImxlZnRDbGFzc05hbWVzIiwicmlnaHRDbGFzc05hbWVzIiwiQWJzdHJhY3RSZWFjdENvbXBvbmVudCIsInByb3BUeXBlcyIsIlJlYWN0IiwiUHJvcFR5cGVzIiwiZWxlbWVudCIsIm5vZGUiLCJzdHJpbmciXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFFQTs7OztBQUVBOzs7QUFQQTtJQVVNQSxjOzs7Ozs7Ozs7O2lDQVFPO0FBQUEseUJBQ3dFLEtBQUtDLEtBRDdFO0FBQUEsZ0JBQ0VDLElBREYsVUFDRUEsSUFERjtBQUFBLGdCQUNRQyxRQURSLFVBQ1FBLFFBRFI7QUFBQSxnQkFDa0JDLFNBRGxCLFVBQ2tCQSxTQURsQjtBQUFBLGdCQUM2QkMsYUFEN0IsVUFDNkJBLGFBRDdCO0FBQUEsZ0JBQzRDQyxjQUQ1QyxVQUM0Q0EsY0FENUM7QUFBQSxnQkFDK0RDLEtBRC9EOzs7QUFHTCxnQkFBTUMsb0JBQW9CLDBCQUN0Qiw0QkFEc0IsRUFFdEJKLFNBRnNCLENBQTFCO0FBSUEsZ0JBQU1LLGlCQUFpQiwwQkFDbkIsa0JBRG1CLEVBRW5CSixhQUZtQixDQUF2QjtBQUlBLGdCQUFNSyxrQkFBa0IsMEJBQ3BCLHFCQURvQixFQUVwQkosY0FGb0IsQ0FBeEI7O0FBS0EsbUJBQU87QUFBQTtBQUFBLHlDQUFLLFdBQVdFLGlCQUFoQixJQUF1Q0QsS0FBdkM7QUFDSDtBQUFBO0FBQUEsc0JBQUssV0FBV0UsY0FBaEI7QUFBaUNQO0FBQWpDLGlCQURHO0FBRUg7QUFBQTtBQUFBLHNCQUFLLFdBQVdRLGVBQWhCO0FBQWtDUDtBQUFsQztBQUZHLGFBQVA7QUFJSDs7O0VBNUJ3QlEsZ0M7O0FBQXZCWCxjLENBQ0tZLFMsR0FBWTtBQUNmVixVQUFNVyxnQkFBTUMsU0FBTixDQUFnQkMsT0FEUCxFQUNnQjtBQUMvQlosY0FBVVUsZ0JBQU1DLFNBQU4sQ0FBZ0JFLElBRlgsRUFFaUI7QUFDaENYLG1CQUFlUSxnQkFBTUMsU0FBTixDQUFnQkcsTUFIaEIsRUFHeUI7QUFDeENYLG9CQUFnQk8sZ0JBQU1DLFNBQU4sQ0FBZ0JHLE1BSmpCLENBSXlCO0FBSnpCLEM7a0JBOEJSakIsYyIsImZpbGUiOiJEZXRhaWxMZWZ0SWNvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIC0tXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IGNsYXNzTmFtZXMgZnJvbSAnY2xhc3NuYW1lcyc7XG5pbXBvcnQgQWJzdHJhY3RSZWFjdENvbXBvbmVudCBmcm9tIFwiLi4vQWJzdHJhY3RSZWFjdENvbXBvbmVudFwiO1xuXG5pbXBvcnQgXCIuL0RldGFpbExlZnRJY29uLnNjc3NcIjtcblxuLyoqXG4gKiBLb21wb25lbnRhLCBrdGVyw6Egb2JhbHVqZSBvYnNhaCwga3RlcsO9IG3DoSB2bGV2byBuYSBkZWFpbGt1IHZlbGlrb3UgaWtvbnUsIHNsb3XFvsOtIGkgcHJvIG9zdGF0bsOtIMWZw6Fka3kgcG9kLCBrdGVyw6kgbmVtYWrDrSBpa29udSwgYWxlIG1hasOtIGLDvXQgc3Byw6F2bsSbIG9kc2F6ZW7DqS5cbiAqL1xuY2xhc3MgRGV0YWlsTGVmdEljb24gZXh0ZW5kcyBBYnN0cmFjdFJlYWN0Q29tcG9uZW50IHtcbiAgICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgICAgICBpY29uOiBSZWFjdC5Qcm9wVHlwZXMuZWxlbWVudCwgLy8gYmxvayBzIGlrb25hbWlcbiAgICAgICAgY2hpbGRyZW46IFJlYWN0LlByb3BUeXBlcy5ub2RlLCAvLyBibG9rIHMgb2JzYWhlbVxuICAgICAgICBsZWZ0Q2xhc3NOYW1lOiBSZWFjdC5Qcm9wVHlwZXMuc3RyaW5nLCAgLy8gY2xhc3MgcHJvIGxldm91IMSNw6FzdCBzIGlrb25vdVxuICAgICAgICByaWdodENsYXNzTmFtZTogUmVhY3QuUHJvcFR5cGVzLnN0cmluZywgLy8gY2xhc3MgcHJvIHByYXZPdSDEjcOhc3QgcyBvYnNhaGVtXG4gICAgfTtcblxuICAgIHJlbmRlcigpIHtcbiAgICAgICAgY29uc3Qge2ljb24sIGNoaWxkcmVuLCBjbGFzc05hbWUsIGxlZnRDbGFzc05hbWUsIHJpZ2h0Q2xhc3NOYW1lLCAuLi5vdGhlcn0gPSB0aGlzLnByb3BzO1xuXG4gICAgICAgIGNvbnN0IHdyYXBwZXJDbGFzc05hbWVzID0gY2xhc3NOYW1lcyhcbiAgICAgICAgICAgIFwiZGV0YWlsLWxlZnQtaWNvbi1jb250YWluZXJcIixcbiAgICAgICAgICAgIGNsYXNzTmFtZVxuICAgICAgICApO1xuICAgICAgICBjb25zdCBsZWZ0Q2xhc3NOYW1lcyA9IGNsYXNzTmFtZXMoXG4gICAgICAgICAgICBcImRldGFpbC1sZWZ0LWljb25cIixcbiAgICAgICAgICAgIGxlZnRDbGFzc05hbWVcbiAgICAgICAgKTtcbiAgICAgICAgY29uc3QgcmlnaHRDbGFzc05hbWVzID0gY2xhc3NOYW1lcyhcbiAgICAgICAgICAgIFwiZGV0YWlsLWxlZnQtY29udGVudFwiLFxuICAgICAgICAgICAgcmlnaHRDbGFzc05hbWVcbiAgICAgICAgKTtcblxuICAgICAgICByZXR1cm4gPGRpdiBjbGFzc05hbWU9e3dyYXBwZXJDbGFzc05hbWVzfSB7Li4ub3RoZXJ9PlxuICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9e2xlZnRDbGFzc05hbWVzfT57aWNvbn08L2Rpdj5cbiAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPXtyaWdodENsYXNzTmFtZXN9PntjaGlsZHJlbn08L2Rpdj5cbiAgICAgICAgPC9kaXY+XG4gICAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBEZXRhaWxMZWZ0SWNvbjtcbiJdfQ==